<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
            
                    <h3 class="mb-0">
                        {{ $tc('message.hospitalisations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="">
                <!--                <div class="card-title" v-if="can">-->
                <!--                    <b-button class="mb-2" variant="danger" @click="toAddReason">-->
                <!--                        {{ $t('message.add') }} {{ $tc('message.reasons', 2) }}-->
                <!--                    </b-button>-->
                <!--                </div>-->

                <div class="card">
                    <!--                    <div class="card-body p-1em">-->
                    <!--                        <h3 class="card-title text-center mb-0">-->
                    <!--                            {{ fileNumber }}-->
                    <!--                        </h3>-->
                    <!--                    </div>-->
                    <b-container>
                        <b-row>
                            <b-col col sm="12">
                                <div class="list-group list-group-flush">
                                    <b-row>
                                        <b-col col sm="12" >
                                            <div class="list-group-item">
                                                <h4 class="consultation-item__title">{{ $t('message.institutionConsultation') }}</h4>
                                                <span class="font-weight-bold">                                                    <p class="consultation-item__body"> {{ etablissement }} </p>
                                                </span>
                                            </div>
                                        </b-col>

                                        <b-col col sm="12">
                                            <div class="list-group-item">
                                                <h4 class="consultation-item__title"> {{ $tc('message.reasons', 1) }}:</h4>

                                                <span class="font-weight-bold consultation-item__body">
                                {{ reasons }}
                            </span>
                                            </div>
                                        </b-col>

                                        <b-col col sm="12">
                                            <div class="list-group-item">
                                                <h4 class="consultation-item__title">{{ $t('message.clinicalHistory') }}:</h4>

                                                <span class="font-weight-bold consultation-item__body" v-html="mHospitalisation.histoire_clinique">
                            </span>
                                            </div>
                                        </b-col>
                                        <b-col col sm="12">
                                            <div class="list-group-item">
                                                <h4 class="consultation-item__title">{{ $t('message.lifestyle') }}:</h4>

                                                <span class="font-weight-bold consultation-item__body" v-html="mHospitalisation.mode_de_vie">
                            </span>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col col sm="12">
                                            <div class="list-group-item">
                                                <h4 class="consultation-item__title">{{ $t('message.conclusion') }}:</h4>

                                                <span class="font-weight-bold consultation-item__body" v-html="mHospitalisation.conclusion">
                            </span>
                                            </div>
                                        </b-col>
                                      <b-col col sm="12">
                                        <div class="list-group-item">
                                          <h4 class="consultation-item__title"> {{ $t('message.evolution') }}:</h4>

                                          <span class="font-weight-bold consultation-item__body" v-html="mHospitalisation.evolution">
                            </span>
                                        </div>
                                      </b-col>
                                      <b-col col sm="12">
                                            <div class="list-group-item">
                                                <h4 class="consultation-item__title">{{ $t('message.avis') }}:</h4>

                                                <span class="font-weight-bold consultation-item__body" v-html="mHospitalisation.avis">
                            </span>
                                            </div>
                                        </b-col>
                                        <b-col col sm="12">
                                            <div class="list-group-item">
                                                <h4 class="consultation-item__title">{{ $t('message.exitTreatment') }}:</h4>

                                                <span class="font-weight-bold consultation-item__body" v-html="mHospitalisation.traitement_sortie">
                            </span>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col col sm="12">
                                            <div class="list-group-item">
                                                <h4 class="consultation-item__title">{{ $t('message.entryDate') }}:</h4>

                                                <span class="font-weight-bold consultation-item__body">
                                {{ mHospitalisation.date_entree }}
                            </span>
                                            </div>
                                        </b-col>
                                        <b-col col sm="12">
                                            <div class="list-group-item">
                                                <h4 class="consultation-item__title">{{ $t('message.exitDate') }}:</h4>

                                                <span class="font-weight-bold consultation-item__body">
                                {{ mHospitalisation.date_sortie }}
                            </span>
                                            </div>
                                        </b-col>
                                        <b-col col sm="12" v-if="mHospitalisation.rdv">
                                            <div class="list-group-item">
                                                <h4 class="consultation-item__title">{{ $t('message.appointmentDate') }} </h4>

                                                <p class="consultation-item__body" v-html="mHospitalisation.rdv.date"></p>

                                            </div>
                                        </b-col>
                                        <b-col col sm="12" v-if="mHospitalisation.rdv">
                                            <div class="list-group-item">
                                                <h4 class="consultation-item__title">{{ $t('message.appointmentReason') }} </h4>

                                                <p class="consultation-item__body" v-html="mHospitalisation.rdv.motifs"></p>

                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col col sm="12">
                                            <div class="list-group-item">
                                                {{ $t('message.passedAt') }}:

                                                <span class="font-weight-bold">
                                {{ formattedDate(mHospitalisation.passed_at) }}
                            </span>
                                            </div>
                                        </b-col>
                                        <b-col col sm="12">
                                            <div class="list-group-item">
                                                {{ $t('message.archievedAt') }}:

                                                <span class="font-weight-bold">
                                {{ formattedDate(mHospitalisation.archived_at) }}
                            </span>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                            <b-col col sm="4">

                                <div class="card-footer text-right" v-if="can">
                                    <b-container>
                                        <b-row class="justify-content-sm-center">
                                <span v-if="errorshasField('nonTransmis')" style="color:red">
                                    {{getErrorsField('nonTransmis')}}
                                    </span>
                                        </b-row>
                                        <b-row class="justify-content-sm-center">
                                            <div class="card-footer text-right">
                                                <div v-if="!hasGestionnaireRole" @click="ImprimerHospitalisation" class="custom-print-wrapper mb-3">
                                                    <button class="custom-print-button">
                                                        <span class="custom-print-icon"></span>
                                                    </button>
                                                    <p class="custom-print-label">
                                                        {{ $t('message.print') }}  {{ $t('message.rapport') }}
                                                    </p>
                                                </div>

                                                <b-button variant="primary" class="mb-5" @click="updateHospitalisation" v-if="mHospitalisation.isAuthor || hasAdminRole">
                                                    {{ $t('message.edit') }}
                                                </b-button>

                                                <b-button class="mb-5" variant="success" @click="archieve" v-if="!isTransmitted(mHospitalisation.passed_at) && isArchived(mHospitalisation.archived_at) && (hasMedecinControleRole || hasAdminRole || hasAssistante)" >
                                                    {{ $t('message.archieve') }}
                                                </b-button>

                                                <b-button class="mb-5" variant="info" @click="transmit" v-if="isTransmitted(mHospitalisation.passed_at) && mHospitalisation.isAuthor && (hasPraticienRole || hasAdminRole || hasMedecinControleRole || hasAssistante)">
                                                    {{ $t('message.transmit') }}
                                                </b-button>

                                                <b-button v-b-modal.delete-modal variant="danger" v-if="mHospitalisation.isAuthor || hasAdminRole">
                                                    {{ $t('message.delete') }}
                                                </b-button>
                                            </div>
                                        </b-row>
                                    </b-container>
                                </div>

                                <b-modal
                                        id="delete-modal"
                                        size="sm"
                                        header-bg-variant="danger"
                                        header-text-variant="light"
                                        :title="$t('message.delete') + ' ' + $tc('message.hospitalisations', 1)"
                                        hide-footer
                                        v-if="can"
                                >
                                    <div class="d-block text-center">
                                        <h3>{{ $t('message.delete') }} {{ mHospitalisation.intitule }}?</h3>
                                    </div>

                                    <div class="d-block float-right">
                                        <b-button variant="danger" @click="deleteHospitalisation" v-if="mHospitalisation.isAuthor || hasAdminRole">
                                            {{ $t('message.delete') }}
                                        </b-button>

                                        <b-button variant="secondary" @click="$bvModal.hide('delete-modal')" >
                                            {{ $t('message.cancel') }}
                                        </b-button>
                                    </div>
                                </b-modal>
                            </b-col>
                        </b-row>
                    </b-container>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from "lodash";


    export default {
        name: "Hospitalisation",

        computed: {
            ...mapGetters(["hospitalisation",
                'hasGestionnaireRole',
                'errors',
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole']),

            mHospitalisation: function() {
                return this.hospitalisation;
            },

            etablissement:function(){
                if (!_.isUndefined(this.mHospitalisation.etablissement)){
                    if (!_.isNull(this.mHospitalisation.etablissement)){
                        return this.mHospitalisation.etablissement.name;
                    }
                    return "";
                }
                return  "";
            },

            fileNumber:function () {
                if (typeof this.hospitalisation.dossier == 'object')
                    return this.hospitalisation.dossier.numero_dossier;
                return "";
            },

            can:function(){
                return this.hasAdminRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            reasons:function(){
                let motifs ="";
                if(!_.isUndefined(this.mHospitalisation.motifs)){
                    _.forEach(this.mHospitalisation.motifs,function (motif,key) {
                        motifs +=  (key != 0 ?" ,":"")+motif.description;
                    })
                    return motifs+".";
                }

                return motifs;
            },
        },

        data() {
            return {
                hospitalisation_id: this.$route.params.hospitalisation
            }
        },

        methods: {
            ImprimerHospitalisation(){
                let args = {
                    hospitalisation: this.hospitalisation_id
                };

                this.$store.dispatch("printHospitalisation", { args });
            },

            getHospitalisation() {
                let args = {
                    hospitalisation: this.hospitalisation_id
                };

                this.$store.dispatch("getHospitalisation", { args });
            },

            toPhysicalExams() {
                this.$router.push({ name: 'hospitalisation.physical-exams', params: { hospitalisation: this.hospitalisation_id } })
            },

            toComplementaryExams() {
                this.$router.push({ name: 'hospitalisation.complementary-exams', params: { hospitalisation: this.hospitalisation_id } })
            },

            toAddReason() {
                this.$router.push({ name: 'add-hospitalisation-reason', params: { hospitalisation: this.hospitalisation_id } })
            },

            updateHospitalisation() {
                this.$router.push({ name: 'edit-hospitalisation', params: { hospitalisation: this.hospitalisation_id } });
            },

            deleteHospitalisation() {
                let self = this;
                let args = {
                    hospitalisation: this.hospitalisation_id
                };

                let successMessage = this.$i18n.t('message.hospitalisationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteHospitalisation', { args, index: self.hospitalisation_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },

            archieve(){
                let self = this;
                let args = {
                    hospitalisation: this.hospitalisation_id
                };

                let successMessage = this.$i18n.t('message.hospitalisationArchieved');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('archieveHospitalisation', { args, index: self.hospitalisation_id, successMessage, errorMessages });

            },

            transmit(){
                this.clearErrorField('nonTransmis');
                let self = this;
                let args = {
                    hospitalisation: this.hospitalisation_id
                };

                let successMessage = this.$i18n.t('message.hospitalisationTransmitted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('transmitHospitalisation', { args, index: self.hospitalisation_id, successMessage, errorMessages });

            },

            isArchived:function(date){
                let momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            isTransmitted:function(date){
                var momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            },

            formattedDate(date) {
                return date ? moment(date).format('DD-MM-YYYY') : 'not yet';
            },
        },

        mounted() {
            this.getHospitalisation();
        }
    }
</script>

<style scoped>

</style>